import { render, staticRenderFns } from "./MsInput.vue?vue&type=template&id=efda460c&scoped=true"
import script from "./MsInput.vue?vue&type=script&lang=js"
export * from "./MsInput.vue?vue&type=script&lang=js"
import style0 from "./MsInput.vue?vue&type=style&index=0&id=efda460c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda460c",
  null
  
)

export default component.exports